import { z } from "zod";

/**
 * 共通パスワードバリデーションスキーマ
 * - 8文字以上
 * - 数字を1文字以上
 * - 英小文字を1文字以上
 * - 英大文字を1文字以上
 * - 特殊文字を1文字以上
 */
export const passwordSchema = z
	.string()
	.min(8, "パスワードは8文字以上で入力してください。")
	.regex(/[0-9]+/, { message: "数字を1文字以上使用してください。" })
	.regex(/[a-z]+/, { message: "英小文字を1文字以上使用してください。" })
	.regex(/[A-Z]+/, { message: "英大文字を1文字以上使用してください。" })
	.regex(/[^a-zA-Z0-9]+/, {
		message: "特殊文字を1文字以上使用してください。",
	});

export const emailSchema = z.object({
	email: z.string().email({
		message: "メールアドレスを入力してください。",
	}),
});

export type EmailFormValue = z.infer<typeof emailSchema>;

export const loginSchema = z.object({
	email: z.string().email({
		message: "メールアドレスを入力してください。",
	}),
	password: passwordSchema,
});

export type LoginFormValue = z.infer<typeof loginSchema>;

export const initPWSchema = z.object({
	tempPassword: passwordSchema,
	newPassword: passwordSchema,
	newConfirmPassword: passwordSchema,
});

export type InitPWFormValue = z.infer<typeof initPWSchema>;

export const resetPWSchema = z
	.object({
		confirmationCode: z.string().length(6, {
			message: "認証コードは6桁の数字です。",
		}),
		newPassword: passwordSchema,
		newConfirmPassword: passwordSchema,
	})
	.refine((data) => data.newPassword === data.newConfirmPassword, {
		path: ["newConfirmPassword"],
		message: "新しいパスワードと確認用パスワードが一致しません。",
	});

export type ResetPWFormValue = z.infer<typeof resetPWSchema>;
